import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SpinnerSection from "../../../components/spinner/spinnerSecion";
import { detailTrainingEditMain, detailTrainingSingle } from "../../../config/apiSPA";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import ListGroupType1 from "./trainingReportMainDataComponent/listGroupType1";
import ListGroupType2 from "./trainingReportMainDataComponent/listGroupType2";
import ListGroupType3 from "./trainingReportMainDataComponent/listGroupType3";
import ListGroupType4 from "./trainingReportMainDataComponent/listGroupType4";
import ModalEditSelect2 from "../../../components/modal/modalEditSelect2";
import ModalEditDate2 from "../../../components/modal/modalEditDate2";
import ModalEditTextArea from "../../../components/modal/modalEditTextArea";
import ModalInfo from "../../../components/modal/modalInfo";
const selectModalOptions = [
  { title: "Training Title", text: "Please select training title from this list", selector: "trainingTitle" },
  { title: "Training Location", text: "Please select training location from this list", selector: "location" },
  { title: "Training Instructor/Fasilitator", text: "Please select training Instructor/Fasilitator from this list", selector: "instructor" },
  { title: "Training Institution", text: "Please select training Institution from this list", selector: "institution" },
];
const dateModalOptions = [
  {
    title: "Edit End Date",
    text: "Please edit training end date",
    selector: "endDate",
  },
  {
    title: "Edit Start Date",
    text: "Please edit training Start date",
    selector: "startDate",
  },
];
const longTextModalOptions = [
  {
    title: "Edit Remark",
    text: "Please Edit Remark",
    selector: "remark",
  },
];
const loadingRadioInitialState = {
  isAtmp: false,
  isKpi: false,
};
const selectModalInitialState = { id: null, selector: "", selected: null };
const dateActiveModalInitialState = { id: null, selector: "", currentDate: "" };
const longTextModalInitialState = { id: null, selector: "", currentValue: "" };
const infoModalInitialState = { show: false, title: "", text: "", theme: "" };
/**
 *
 * @param {{mainDataRet?:()=>void}} props
 * @returns {JSX.Element}
 */
function TrainingReportMainData({ mainDataRet = () => {} }) {
  const { id } = useParams();
  const [mainData, setmainData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [selectActiveModal, setSelectActiveModal] = useState(selectModalInitialState);
  const [dateActiveModal, setDateActiveModal] = useState(dateActiveModalInitialState);
  const [longTextActiveModal, setLongTextActiveModal] = useState(longTextModalInitialState);
  const [infoModal, setInfoModal] = useState(infoModalInitialState);
  const [loadingRadioState, setLoadingRadioState] = useState(loadingRadioInitialState);
  const handleClickSelect = (selector, selected) => {
    setSelectActiveModal({ id, selector, selected });
  };
  const handleSubmitSelectModal = async ({ id, selector, val }) => {
    setSelectActiveModal(selectModalInitialState);
    try {
      const payload = { trainingId: id, selector, value: val };
      const res = await detailTrainingEditMain(payload);
      setmainData(res.data);
    } catch (error) {
      setInfoModal({
        show: true,
        title: "Error",
        text: `Failed to edit : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleClickDate = (selector, currentDate) => {
    setDateActiveModal({ id, selector, currentDate });
  };
  const handleSubmitDateModal = async ({ id, val, selector }) => {
    setDateActiveModal(dateActiveModalInitialState);
    try {
      const payload = { trainingId: id, selector, value: val };
      const res = await detailTrainingEditMain(payload);
      setmainData(res.data);
    } catch (error) {
      setInfoModal({
        show: true,
        title: "Error",
        text: `Failed to edit : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleClickLongText = (selector, currentValue) => {
    setLongTextActiveModal({ selector, id, currentValue });
  };
  const handlesubmitLongTextModal = async ({ id, val, selector }) => {
    setLongTextActiveModal(longTextModalInitialState);
    try {
      const payload = { trainingId: id, selector, value: val };
      const res = await detailTrainingEditMain(payload);
      setmainData(res.data);
    } catch (error) {
      setInfoModal({
        show: true,
        title: "Error",
        text: `Failed to edit : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleChangeRadio = async (selector, e) => {
    setLoadingRadioState((a) => ({ ...a, [selector]: true }));
    try {
      const payload = { trainingId: id, selector, value: e };
      const res = await detailTrainingEditMain(payload);
      setmainData(res.data);
    } catch (error) {
      setInfoModal({
        show: true,
        title: "Error",
        text: `Failed to edit : ${error.message}`,
        theme: "danger",
      });
    } finally {
      setLoadingRadioState(loadingRadioInitialState);
    }
  };
  const loadData = async () => {
    try {
      const res = await detailTrainingSingle(id);
      setmainData(res.data);
      mainDataRet(res.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">General</CardHeader>
        <CardBody>
          {isLoading ? (
            <SpinnerSection title="Loading..." />
          ) : (
            <>
              <ListGroupType1 label="Training Title" value={mainData.trainingCode.title} onClick={() => handleClickSelect("trainingTitle", mainData.trainingCode.id)} />
              <ListGroupType3 label="Training Code" value={mainData.trainingCode.code} />
              <ListGroupType2 label="ATMP/NON-ATMP?" defaultValue={mainData.atmp} onChange={(e) => handleChangeRadio("isAtmp", e)} isLoading={loadingRadioState.isAtmp} option1="ATMP" option2="non-ATMP" name="radio_1" />
              <ListGroupType2 label="Count as KPI?" defaultValue={mainData.kpi} onChange={(e) => handleChangeRadio("isKpi", e)} isLoading={loadingRadioState.isKpi} option1="Yes" option2="No" name="radio_2" />
              <ListGroupType1 label="Location" value={mainData.locationData.location} onClick={() => handleClickSelect("location", mainData.locationData.id)} />
              <ListGroupType1 label="Instructor" value={mainData.instructorData.namaInstructor} onClick={() => handleClickSelect("instructor", mainData.instructorData.id)} />
              <ListGroupType1 label="Institution" value={mainData.institutionData.institutionName} onClick={() => handleClickSelect("institution", mainData.institutionData.id)} />
              <ListGroupType1 label="Start Date" value={mainData.startDate} onClick={(val) => handleClickDate("startDate", mainData.startDate)} />
              <ListGroupType1 label="End Date" value={mainData.endDate} onClick={(val) => handleClickDate("endDate", mainData.startDate)} />
              <ListGroupType4 label="Remark" value={mainData.remark} onClick={(val) => handleClickLongText("remark", mainData.remark)} />
            </>
          )}
        </CardBody>
      </Card>
      {selectModalOptions.map(({ selector, title, text }) => (
        <ModalEditSelect2
          key={selector}
          options={{ title, text }}
          selected={selectActiveModal.selected}
          id={selectActiveModal.id}
          show={selectActiveModal.selector === selector}
          onHide={() => setSelectActiveModal((a) => ({ ...a, selector: "" }))}
          selector={selector}
          submitClick={(val) => handleSubmitSelectModal({ ...val, selector })}
        />
      ))}
      {dateModalOptions.map(({ title, text, selector }) => (
        <ModalEditDate2
          key={selector}
          options={{ text, title }}
          currentDate={dateActiveModal.currentDate}
          id={dateActiveModal.id}
          show={dateActiveModal.selector === selector}
          onHide={() => setDateActiveModal((a) => ({ ...a, selector: "" }))}
          submitClick={(val) => handleSubmitDateModal({ ...val, selector })}
        />
      ))}
      {longTextModalOptions.map(({ title, text, selector }) => (
        <ModalEditTextArea
          key={selector}
          options={{ title, text }}
          currentValue={longTextActiveModal.currentValue}
          id={longTextActiveModal.id}
          show={longTextActiveModal.selector === selector}
          onHide={() => setLongTextActiveModal((a) => ({ ...a, selector: "" }))}
          submitClick={(val) => handlesubmitLongTextModal({ ...val, selector })}
        />
      ))}
      <ModalInfo show={infoModal.show} theme={infoModal.theme} text={infoModal.text} title={infoModal.title} onHide={() => setInfoModal(infoModalInitialState)} clicked={() => setInfoModal(infoModalInitialState)} />
    </>
  );
}

export default TrainingReportMainData;
